<template>
  <div class="card p-3 shadow">
    <ul class="nav nav-pills justify-content-end mb-2">
      <li class="nav-item">
        <a
            :class="'nav-link ' + (view === 'prescriptions' ? 'active' : '')"
            href="#"
            @click="view = 'prescriptions'">
          Назначения
        </a>
      </li>

      <li class="nav-item">
        <a
            :class="'nav-link ' + (view === 'calendar' ? 'active' : '')"
            href="#"
            @click="view = 'calendar'">
          Календарь
        </a>
      </li>
    </ul>

    <CheckupCalendar
        v-if="view === 'calendar'"
        :catalogs="catalogs"
        :prescriptions="prescriptions"
        :answers="answers"/>
    <CheckupPrescriptions
        :catalogs="catalogs"
        :items="items"
        :updatePrescription="updatePrescription"
        v-else/>
  </div>
</template>

<script>
  import CheckupCalendar from './checkup/Calendar';
  import CheckupPrescriptions from './checkup/Prescriptions';

  export default {
    name: 'Checkup',

    components: {CheckupCalendar, CheckupPrescriptions},

    props: ['client'],

    data() {
      return {
        view: 'calendar',
        updating: [],
      };
    },

    created() {
      this.loadData();
    },

    computed: {
      catalogs() {
        const catalogs = this.$store.state.checkup.catalogs.map(
          ({id, name, parent, sort}) => ({id, name, parent, sort})
        );

        catalogs.push({id: null, name: 'Без каталога', parent: null, sort: 0});

        return catalogs;
      },

      answers() {
        return this.$store.getters.clientCheckupAnswers(this.client.id);
      },

      prescriptions() {
        const prescriptions = this.$store.getters.clientCheckupPrescriptions(this.client.id);

        return prescriptions.map(prescription => {
          const {active, comment, user, id} = prescription;
          const fields = prescription.item.fields.map(field => {
            const {id, label, type, level, sort, note} = field;
            const strength = [80, 60, 40, 20, 1].find(l => l <= level) || 0;

            return {id, label, type, level, sort, note, strength};
          });

          const item = {
            id: prescription.item.id,
            catalog: prescription.item.catalog,
            description: prescription.item.description,
            multiple: prescription.item.multiple,
            sort: prescription.item.sort,
            title: prescription.item.title,
            type: prescription.item.type,
            fields
          };

          return {active, comment, user, id, item};
        });
      },

      items() {
        const prescribed = {};

        this.prescriptions.forEach(({item, active}) => {
          prescribed[item.id] = active;
        });

        return this.$store.state.checkup.items.map(item => {
          const {id, title, type, multiple, sort, catalog, description} = item;
          const isPrescribed = prescribed[id] === true;
          const updating = this.updating.includes(id);

          const fields = item.fields.map(field => {
            const {id, label, type, level, sort, note} = field;
            const strength = [80, 60, 40, 20, 1].find(l => l <= level) || 0;

            return {id, label, type, level, sort, note, strength};
          });

          return {id, title, type, multiple, sort, catalog, description, fields, isPrescribed, updating};
        });
      },
    },

    methods: {
      async loadData() {
        try {
          await Promise.all([
            this.$store.dispatch('LOAD_CHECKUP_CATALOGS', this.client.id),
            this.$store.dispatch('LOAD_CHECKUP_ITEMS', this.client.id),
            this.$store.dispatch('LOAD_CHECKUP_PRESCRIPTIONS', this.client.id),
            this.$store.dispatch('LOAD_CHECKUP_ANSWERS', this.client.id)
          ]);
        } catch (e) {
          this.$store.dispatch('ERROR', e);
        }
      },

      async updatePrescription(id, state) {
        const prescription = this.prescriptions.find(
          prescription => prescription.item.id === id
        );
        const action = !prescription ? 'ADD_CHECKUP_PRESCRIPTION' : 'UPDATE_CHECKUP_PRESCRIPTION';
        const payload = {
          id: prescription ? prescription.id : null,
          client: this.client.id,
          data: {item: id, isActive: state}
        };

        if (!prescription) {
          Object.assign(payload.data, {user: this.client.id});
        }

        try {
          this.updating.push(id);

          await this.$store.dispatch(action, payload);

          this.updating = this.updating.filter(item => item !== id);
        } catch (e) {
          this.$store.dispatch('ERROR', e);
        }
      },
    },
  };
</script>

<style lang="scss">
  .checkup-strength-80 {
    color: #fff;
    background-color: #059526;
  }

  .checkup-strength-60 {
    color: #fff;
    background-color: #91C139;
  }

  .checkup-strength-40 {
    background-color: #ffc107;
  }

  .checkup-strength-20 {
    color: #fff;
    background-color: #dc3545;
  }

  .checkup-strength-1 {
    color: #fff;
    background-color: darkred;
  }

  .checkup-strength-0 {
    color: #333;
    background-color: #ccc;
  }
</style>
